// Native details stay usable without JavaScript; deep links reveal their content.
function revealLinkedDetail(hash = window.location.hash) {
  let anchor;
  try { anchor = decodeURIComponent(hash.slice(1)); } catch { return; }
  if (!anchor) return;
  const target = document.getElementById(anchor);
  if (!target) return;
  // Open outer categories before the course itself, including category-only links.
  const ancestors=[];let parent=target.parentElement;
  while(parent){if(parent instanceof HTMLDetailsElement)ancestors.unshift(parent);parent=parent.parentElement;}
  ancestors.forEach(detail=>detail.open=true);
  if (target instanceof HTMLDetailsElement) target.open = true;
  else target.querySelector(':scope > .oh-wrap > [data-course-category]')?.setAttribute('open','');
}
window.addEventListener('hashchange', () => revealLinkedDetail());
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => revealLinkedDetail());
else revealLinkedDetail();

// Clicking the current hash does not fire hashchange. Open before the browser's
// normal anchor navigation, preserving scrolling, history and keyboard behavior.
document.addEventListener('click', event => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
  let destination;
  try { destination = new URL(link.href, window.location.href); } catch { return; }
  if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search) return;
  revealLinkedDetail(destination.hash);
});

// Equipment consent travels with the native cart POST. This is a storefront gate,
// not server-side checkout validation; staff must check the record before capture.
(() => {
  const gateSelector='[data-equipment-acknowledgment]';
  const initialized=new WeakSet();
  function reset(gate,message='') {
    const checkbox=gate.querySelector('input[type="checkbox"]');
    checkbox.checked=false;
    gate.querySelectorAll('[data-equipment-ack-record]').forEach(field=>field.disabled=true);
    checkbox.removeAttribute('aria-invalid');
    const error=gate.querySelector('[data-equipment-ack-error]');
    if(message)error.textContent=message;
    error.hidden=!message;
  }
  function setup() {
    document.querySelectorAll(gateSelector).forEach(gate=>{
      if(initialized.has(gate))return;
      initialized.add(gate);reset(gate);
      gate.querySelector('input[type="checkbox"]').addEventListener('invalid',()=>{
        gate.querySelector('[data-equipment-ack-error]').hidden=false;
      });
    });
    if(document.querySelector(gateSelector+', [data-equipment-quote-block]'))
      document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(node=>node.hidden=true);
  }
  function validate(form) {
    const quote=document.querySelector('[data-equipment-quote-block]');
    if(quote){quote.setAttribute('tabindex','-1');quote.focus();return false;}
    const gate=[...document.querySelectorAll(gateSelector)].find(node=>!form||node.querySelector('input[type="checkbox"]').form===form);
    if(!gate)return true;
    const checkbox=gate.querySelector('input[type="checkbox"]');
    if(checkbox.checked&&!checkbox.disabled)return true;
    checkbox.setAttribute('aria-invalid','true');
    gate.querySelector('[data-equipment-ack-error]').hidden=false;
    checkbox.focus();checkbox.reportValidity();return false;
  }
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target.closest('button[name="checkout"],input[name="checkout"],a[href]'):null;
    if(!target)return;
    if(target.tagName==='A'){
      const destination=new URL(target.href,location.href);
      if(destination.origin!==location.origin||!/(?:^|\/)checkout\/?$/.test(destination.pathname))return;
    }
    if(!validate(target.form)){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('submit',event=>{
    if(!['cart','CartDrawer-Form'].includes(event.target.id))return;
    if(event.submitter&&event.submitter.name!=='checkout')return;
    if(!validate(event.target)){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('change',event=>{
    const input=event.target;
    if(!(input instanceof HTMLInputElement))return;
    const gate=input.closest(gateSelector);
    if(gate&&input.type==='checkbox'){
      gate.querySelectorAll('[data-equipment-ack-record]').forEach(field=>field.disabled=!input.checked);
      input.removeAttribute('aria-invalid');gate.querySelector('[data-equipment-ack-error]').hidden=true;return;
    }
    if(input.name==='updates[]'||input.name.startsWith('updates['))
      document.querySelectorAll(gateSelector).forEach(node=>{
        reset(node,'Your cart changed. Review the updated cart and accept the equipment terms again.');
        node.querySelector('input[type="checkbox"]').disabled=true;
      });
  },true);
  window.addEventListener('pageshow',()=>document.querySelectorAll(gateSelector).forEach(gate=>reset(gate)));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
  new MutationObserver(()=>{
    setup();
    if([...document.querySelectorAll('.cart-item__error-text,#cart-errors')].some(node=>node.textContent.trim()))
      document.querySelectorAll(gateSelector+' input[type="checkbox"]:disabled').forEach(input=>input.disabled=false);
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
